import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowUp from '../../images/arrow-up.svg';
import ArrowDown from '../../images/arrow-down.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '20px 0',
  },
  selectedTypesRoot: {
    height: 45,
    width: '100%',
    position: 'relative',
    border: '1px solid #E9ECED',
    borderRadius: 2,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    overflow: 'hidden',
  },
  disabled: {
    cursor: 'default',
  },
  sortText: {
    color: '#A6A6A6',
    ...theme.typography.pxSmall,
    marginRight: 5,
  },
  selectedSortText: {
    ...theme.typography.pxSmall,
    width: 96,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  arrowIcon: {
    position: 'absolute',
    right: 5,
    [theme.breakpoints.down('991')]: {
      right: 15,
    },
  },
  selectedListText: {
    color: theme.palette.primary.main,
  },
}));

const OPTIONS = ['Latest', 'Company Blog', 'Ambassador Blog'];

function BlogTypeSelector({ activeType, clickHandler }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorWidth, setAnchorWidth] = useState();
  const menuBlock = useRef();

  useEffect(() => {
    setAnchorWidth(menuBlock.current.clientWidth);
  }, []);

  const handleClick = event => {
    const { currentTarget } = event;
    setAnchorEl(anchorEl ? null : currentTarget);
  };

  const handleChange = el => {
    clickHandler(el);
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'menu-popper' : null;
  const selectedIndex = OPTIONS.indexOf(activeType);
  /*eslint-disable*/
  return (
    <div className={classes.root}>
      <div
        className={_classNames({
          [classes.selectedTypesRoot]: true,
        })}
        role="button"
        aria-describedby={id}
        onClick={handleClick}
        ref={menuBlock}
      >
        <Typography color="textPrimary" className={classes.selectedSortText}>
          {OPTIONS[selectedIndex]}
        </Typography>
        <img
          src={open ? ArrowUp : ArrowDown}
          className={classes.arrowIcon}
          alt="arrow"
        />
      </div>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        disablePortal
      >
        <Paper style={{width: anchorWidth}}>
          <List disablePadding>
            {OPTIONS.map(el => {
              const isSelected = activeType === el;
            return <ListItem
                key={el}
                onClick={() => handleChange(el)}
              >
                <ListItemText
                  primary={el}
                  classes={{
                    primary: isSelected && classes.selectedListText
                  }}
                />
              </ListItem>
            })}
          </List>
        </Paper>
      </Popper>
    </div>
  );
}

BlogTypeSelector.propTypes = {
  activeType: PropTypes.string,
  clickHandler: PropTypes.func,
  classes: PropTypes.object,
};

export default BlogTypeSelector;
